import { useState } from 'react'

const getDefaultDates = () => {
  const dateEnd = new Date()
  const dateStart = new Date(dateEnd)
  dateStart.setFullYear(dateEnd.getFullYear() - 10)

  return {
    defaultDateStart: dateStart.toISOString().split('T')[0],
    defaultDateEnd: dateEnd.toISOString().split('T')[0],
  }
}

export const useGetAnswer = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const { defaultDateStart, defaultDateEnd } = getDefaultDates()

  const getAnswer = (
    question: string,
    tenants: string[],
    dateStart: string = defaultDateStart,
    dateEnd: string = defaultDateEnd
  ): Promise<ChatInterface> => {
    setIsLoading(true)
    setErrorMessage(null)

    console.log(dateStart, dateEnd)

    // return new Promise((resolve, reject) => {
    //   setIsLoading(false)
    //   resolve({
    //     id: 1234,
    //     type: 'bot',
    //     date: new Date(),
    //     text: `
    //     <p>Vestibulum rutrum sagittis <strong>mauris in</strong> dictum. Vestibulum non tristique risus.</p>
    //     <p>Quisque luctus leo ut sapien pretium, a convallis turpis cursus.</p>
    //     <ul>
    //     <li>Sed sit amet velit et neque tempus auctor.</li>
    //     <li>Mauris placerat ex quis placerat dictum.</li>
    //     </ul>
    //     <p>Duis egestas ipsum ut eleifend gravida. Mauris eu eleifend magna.</p>
    //     `,
    //     articles: [],
    //   })
    // })

    return fetch(
      'https://vszdnd4ole.execute-api.eu-central-1.amazonaws.com/default/ttyod-container',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': 'XrbzUITRWe5EEVr20HtsO4oG8mn81RTt4a2Db121',
        },
        body: JSON.stringify({
          task: 'article_chat',
          question: question,
          target: 'test_target',
          conversationId: 'test_conversationId',
          chat_history: [
            {
              answer: 'not_yet_used',
              question: 'not_yet_used',
            },
            {
              answer: 'not_yet_used',
              question: 'not_yet_used',
            },
          ],
          userId: 'test_uid',
          filters: {
            // isPermium: 'False',
            dateStart: dateStart,
            dateEnd: dateEnd,
            newspapers: tenants,
          },
          resources: ['not_yet_supportet'],
          parameters: {
            llm: 'gpt-4',
            top_k: '5',
            prompt: `
              You are a journalist dedicated to high quality journalism in Geneva, Switzerland.
              Factual correctness is very important. Only use facts and information from the context provide.
              No judgement. If you cant answer based on the context then just tell that. Always in French.
              Format the answer with HTML tags in order to make them look pretty. Especially for paragraphs and lists.
              Be as detailed as possible.
            `,
          },
          // max_tokens: '100',
        }),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        setIsLoading(false)
        const date = new Date()

        console.log(response)

        // Extract the ids from the resources
        const regex = /\b(\d+)\|/g
        const matches = response.resources.match(regex)
        let articleIds: Array<string | number> = []

        if (matches) {
          articleIds = matches.map((match: string) => match.replace('|', ''))
        }

        const ids = response.resources.split(',').map((r: string) => ({
          tenant: r.split(':')[0],
          id: r.split('|')[0].replace(/.+:\s/, ''),
          chunk: r.split('|')[1],
        }))

        return {
          id: date.valueOf(),
          text: response.answer.content,
          type: 'bot' as 'bot',
          date: date,
          articles: articleIds,
        }
      })
      .catch((error) => {
        setIsLoading(false)
        setErrorMessage(error.message)
        return Promise.reject(error)
      })
  }

  return { getAnswer, isLoading, errorMessage }
}
